// 유사 이력 임계값 일괄 반영(순수) — 대상 수집만. 반영(editedHsk)은 패널이 수행.

/**
 * 그리드 행들 중 [일치율 >= threshold && 유사세번 존재 && 마스터 정확일치 아님] 행의
 * 원본 행 인덱스 전개 목록을 만든다. members 없으면 _srcRow 폴백.
 */
export function collectSimilarBulkTargets(rows, threshold) {
  const out = [];
  for (const r of rows || []) {
    if (!r || !r._simHsk || (r._simRate || 0) < threshold) continue;
    if (r.masterHsk) continue;
    const members = r._members || (r._srcRow != null ? [r._srcRow] : []);
    members.forEach((src) => out.push({ src, hsk: r._simHsk }));
  }
  return out;
}

/**
 * 확정 시 저장할 세번 해석 — 수동수정(editedHsk)이 항상 우선(그리드 표시와 동일 규칙).
 * row가 stale 스냅샷이어도 editedHsk 맵이 최신이므로 [적용]→[확정] 시 적용값이 저장된다.
 */
export function resolveConfirmHsk(row, editedHskMap) {
  if (!row) return "";
  const src = row._srcRow != null ? row._srcRow : row.idx;
  const edited = src != null && editedHskMap && editedHskMap.get(src);
  return edited || row._finalHsk || row.finalHsk || "";
}
